import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormModule } from '@capturum/formly';
import { ValidatorService } from '@capturum/ui/api';
import { CapturumButtonModule } from '@capturum/ui/button';
import { CapturumPasswordModule } from '@capturum/ui/password';
import { controlsEqual } from '@core/validators/control-equals.validator';
import { passwordValidator } from '@core/validators/password.validator';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { generateRandomPassword } from '@shared/utils/common.util';

@Component({
  selector: 'app-formly-password-with-confirm-type',
  imports: [
    FormlyModule,
    FormsModule,
    FormModule,
    ReactiveFormsModule,
    CapturumPasswordModule,
    TranslateModule,
    CapturumButtonModule,
  ],
  templateUrl: './formly-password-with-confirm-type.component.html',
  styleUrl: './formly-password-with-confirm-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FormlyPasswordWithConfirmTypeComponent extends FieldType implements OnInit {
  public passwordFormGroup: FormGroup;

  private destroyRef = inject(DestroyRef);
  private formBuilder = inject(FormBuilder);
  private validatorService = inject(ValidatorService);

  constructor() {
    super();

    this.validatorService.setValidationMessages({
      fieldMatch: 'auth.reset-password.mismatch.message',
    });
  }

  public ngOnInit(): void {
    this.passwordFormGroup = this.formBuilder.group(
      {
        password: [null, passwordValidator],
        confirm_password: [null, passwordValidator],
      },
      {
        validators: controlsEqual('confirm_password', 'password', 'fieldMatch'),
      },
    );

    this.passwordFormGroup.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((changes) => {
      this.formControl.setValue(changes);
    });

    this.formControl.statusChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((status) => {
      switch (status) {
        case 'DISABLED':
          this.passwordFormGroup.disable({
            emitEvent: false,
          });
          break;

        default:
          this.passwordFormGroup.enable({
            emitEvent: false,
          });
          break;
      }
    });
  }

  public generatePassword(): void {
    const password = generateRandomPassword();

    this.passwordFormGroup.setValue({
      password,
      confirm_password: password,
    });
  }
}
